import React from 'react';
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Testimonials from '../components/Testimonials';
import HeroSlideshow from '../components/HeroSlideshow';
import Newsletter from '../components/Newsletter';

const { FiArrowRight, FiShield, FiTrendingUp, FiUsers, FiAward } = FiIcons;

const Home = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: FiShield,
      title: 'Maîtrise des Risques',
      description: 'Expertise en qualité, sécurité et environnement selon les normes ISO'
    },
    {
      icon: FiTrendingUp,
      title: 'Excellence Opérationnelle',
      description: 'Amélioration continue et optimisation des processus'
    },
    {
      icon: FiUsers,
      title: 'Développement des Compétences',
      description: 'Formation sur mesure et accompagnement personnalisé'
    },
    {
      icon: FiAward,
      title: 'Certification Internationale',
      description: 'Équipe certifiée IRCA/CQI aux standards mondiaux'
    }
  ];

  const heroFeatures = [
    'Expertise Africaine',
    'Normes ISO Certifiées',
    'Résultats Mesurables'
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="pt-16 lg:pt-20"
    >
      {/* Hero Section with Slideshow and Colors */}
      <HeroSlideshow
        badge="🚀 Pôle d'Excellence QHSE"
        title={
          <>
            Votre Partenaire de <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">Confiance</span>
          </>
        }
        subtitle={
          <>
            Développement de <span className="font-semibold text-white">Compétences</span> et Maîtrise des Risques{' '}
            <span className="font-bold text-cyan-400 drop-shadow-[0_0_10px_rgba(34,211,238,0.5)]">Qualité</span>,{' '}
            <span className="font-bold text-orange-400 drop-shadow-[0_0_10px_rgba(251,146,60,0.5)]">Sécurité</span> et{' '}
            <span className="font-bold text-green-400 drop-shadow-[0_0_10px_rgba(74,222,128,0.5)]">Environnement</span> en Afrique
          </>
        }
        primaryCtaLabel="Découvrir nos Services"
        secondaryCtaLabel="Nous Contacter"
        onPrimaryCtaClick={() => navigate('/services')}
        onSecondaryCtaClick={() => navigate('/contact')}
        features={heroFeatures}
      />

      {/* Features Section */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-4">
              Notre Expertise
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Depuis 2024, nous accompagnons les organisations vers l'excellence opérationnelle
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-800 dark:to-gray-700 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-4">{feature.title}</h3>
                <p className="text-gray-600 dark:text-gray-300">{feature.description}</p>
              </motion.div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/contact"
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-700 to-cyan-600 text-white font-semibold rounded-lg hover:from-blue-800 hover:to-cyan-700 transition-all transform hover:scale-105"
            >
              Démarrer Votre Projet
              <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <Testimonials />

      {/* Newsletter Section - AJOUTÉE ICI */}
      <Newsletter />
    </motion.div>
  );
};

export default Home;